import React, { useState, useEffect } from "react";
import {
  COOKIE_CATEGORIES,
  applyCookieConsent,
  getConsentSettings,
} from "../../utils/cookieManager";
import "./CookieConsent.css";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [settings, setSettings] = useState({
    necessary: true,
    preferences: false,
    statistics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = getConsentSettings();
    if (!consent) {
      setVisible(true);
    } else {
      applyCookieConsent();
      setSettings({
        necessary: true,
        preferences: consent.preferences || false,
        statistics: consent.statistics || false,
        marketing: consent.marketing || false,
      });
    }
  }, []);

  const acceptAll = () => {
    const consent = {
      necessary: true,
      preferences: true,
      statistics: true,
      marketing: true,
      timestamp: new Date().toISOString(),
    };

    localStorage.setItem("cookieConsent", JSON.stringify(consent));
    applyCookieConsent();
    setSettings(consent);
    setVisible(false);
  };

  const acceptNecessary = () => {
    const consent = {
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false,
      timestamp: new Date().toISOString(),
    };

    localStorage.setItem("cookieConsent", JSON.stringify(consent));
    applyCookieConsent();
    setSettings(consent);
    setVisible(false);
  };

  const handleToggle = (category) => {
    if (category === "necessary") return;

    setSettings((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const saveSettings = () => {
    const consent = {
      ...settings,
      timestamp: new Date().toISOString(),
    };

    localStorage.setItem("cookieConsent", JSON.stringify(consent));
    applyCookieConsent();
    setVisible(false);
    setShowSettings(false);
  };

  const SettingsButton = () => (
    <button
      className="fixed-cookie-settings"
      onClick={() => setShowSettings(true)}
    >
      Cookie Settings
    </button>
  );

  if (!visible && !showSettings) {
    return <SettingsButton />;
  }

  return (
    <>
      {visible && (
        <div className="cookie-consent">
          <div className="cookie-consent-container">
            <div className="cookie-content">
              <h2>This website uses cookies</h2>
              <p>
                We use cookies and similar technologies to help personalise
                content, tailor and measure ads, and provide a better
                experience. By clicking 'Accept All' you consent to our use of
                cookies for these purposes.
              </p>
              <p>
                We use essential cookies to help make our site work and deliver
                our services. These cannot be disabled.
              </p>
              <div className="cookie-links">
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                <a
                  href="/terms-of-use"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>
              </div>
            </div>
            <div className="cookie-buttons">
              <button
                className="btn-settings"
                onClick={() => setShowSettings(true)}
              >
                Cookie Settings
              </button>
              <button
                className="btn-necessary"
                onClick={acceptNecessary}
              >
                Necessary Only
              </button>
              <button
                className="btn-accept-all"
                onClick={acceptAll}
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettings && (
        <div className="cookie-settings-overlay">
          <div className="cookie-settings-modal">
            <div className="cookie-settings-header">
              <h2>Cookie Settings</h2>
              <button
                className="close-button"
                onClick={() => setShowSettings(false)}
              >
                ×
              </button>
            </div>
            <div className="cookie-settings-content">
              <p>
                You can choose which cookies you want to allow. You can change
                these settings at any time, although this might affect the
                functionality of the website.
              </p>
              <div className="cookie-categories">
                {Object.entries(COOKIE_CATEGORIES).map(([key, category]) => (
                  <div
                    key={key}
                    className="cookie-category"
                  >
                    <div className="category-header">
                      <div>
                        <h3>{category.name}</h3>
                        {key === "necessary" && (
                          <span className="required-badge">Required</span>
                        )}
                      </div>
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={settings[key]}
                          onChange={() => handleToggle(key)}
                          disabled={key === "necessary"}
                        />
                        <span className="toggle-slider"></span>
                      </label>
                    </div>
                    <p className="category-description">
                      {category.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="cookie-settings-footer">
              <button
                className="btn-cancel"
                onClick={() => setShowSettings(false)}
              >
                Cancel
              </button>
              <button
                className="btn-save"
                onClick={saveSettings}
              >
                Save Preferences
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
